exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".item .remove-item {\n  opacity: 0.45;\n}\n", "", {"version":3,"sources":["/Users/luizmottin/Workspace/Trackmob/trackmob-collect/src/components/filter/item.vue"],"names":[],"mappings":"AAmBA;EACE,cAAa;CAAA","file":"item.vue?vue&type=style&index=0&lang=scss&","sourcesContent":["\n          @import \"~@trackmob/trackui/source/sass/_settings.scss\";\n        \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.item .remove-item {\n  opacity: 0.45;\n}\n"],"sourceRoot":""}]);

// exports
